import styled from 'styled-components';

export const StyledFileItem = styled.div``;
